import { LuminousGallery } from "luminous-lightbox";

const galleryNodes = document.querySelectorAll(".GridGallery__image_container");
if (galleryNodes) {
  new LuminousGallery(galleryNodes);
}
